import { render, staticRenderFns } from "./update1.vue?vue&type=template&id=0456c360&scoped=true"
import script from "./update1.vue?vue&type=script&lang=js"
export * from "./update1.vue?vue&type=script&lang=js"
import style0 from "./update1.vue?vue&type=style&index=0&id=0456c360&lang=css"
import style1 from "./update1.vue?vue&type=style&index=1&id=0456c360&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0456c360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0456c360')) {
      api.createRecord('0456c360', component.options)
    } else {
      api.reload('0456c360', component.options)
    }
    module.hot.accept("./update1.vue?vue&type=template&id=0456c360&scoped=true", function () {
      api.rerender('0456c360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/used/update1.vue"
export default component.exports